/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { styled, useTheme, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import {
  Box,
  Paper,
  Typography,
  IconButton,
  Dialog,
  DialogContent,
  Chip,
  Divider,
  ListItemButton,
  ClickAwayListener,
  Popper,
  Fade,
  InputAdornment,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import TableChartIcon from "@mui/icons-material/TableChart";
import BusinessIcon from "@mui/icons-material/Business";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

// ─── Metadato de categorías ─────────────────────────────────────────────────
const CATEGORY_META = {
  inicio:             { label: "Inicio",               icon: HomeIcon,             color: "primary"   },
  administracion:     { label: "Administración",        icon: ManageAccountsIcon,   color: "secondary" },
  tablas:             { label: "Tablas Generales",      icon: TableChartIcon,       color: "default"   },
  cuentas:            { label: "Cuentas",               icon: BusinessIcon,         color: "info"      },
  comprobantes:       { label: "Comprobantes",          icon: ReceiptLongIcon,      color: "success"   },
  gestion_documental: { label: "Gestión Documental",    icon: FolderCopyIcon,       color: "warning"   },
  articulos:          { label: "Artículos / Comercial", icon: Inventory2Icon,       color: "error"     },
};

// ─── Lista de sugerencias ───────────────────────────────────────────────────
const ALL_SUGGESTIONS = [
  { label: "Inicio",                          url: "/dashboard",                        category: "inicio"             },
  { label: "Cerrar Sesión",                   url: "/logout",                           category: "inicio"             },
  { label: "Ayuda",                           url: "/help",                             category: "inicio"             },

  { label: "Módulos",                         url: "/modulos/admin",                    category: "administracion"     },
  { label: "Menú",                            url: "/menu/admin",                       category: "administracion"     },
  { label: "Usuarios",                        url: "/usuarios/admin",                   category: "administracion"     },
  { label: "Perfiles",                        url: "/perfiles/admin",                   category: "administracion"     },
  { label: "Permisos Roles",                  url: "/permisos_roles/admin",             category: "administracion"     },
  { label: "Funcionalidades",                 url: "/funcionalidades/admin",            category: "administracion"     },

  { label: "Géneros",                         url: "/generales/generos/admin",          category: "tablas"             },
  { label: "Estados Civiles",                 url: "/generales/estado_civil/admin",     category: "tablas"             },
  { label: "Alícuotas",                       url: "/generales/alicuotasIVA-list",      category: "tablas"             },
  { label: "Tipo Documento",                  url: "/generales/tipo_documento/admin",   category: "tablas"             },
  { label: "Tipo Servicio Internet",          url: "/generales/tipo_internet/admin",    category: "tablas"             },
  { label: "Tipo Teléfonos",                  url: "/generales/tipo_telefonos/admin",   category: "tablas"             },
  { label: "Maestros Bancos",                 url: "/maestros_bancos/admin",            category: "tablas"             },
  { label: "País",                            url: "/pais/admin",                       category: "tablas"             },
  { label: "Provincias",                      url: "/provincias/admin",                 category: "tablas"             },
  { label: "Departamentos",                   url: "/departamentos/admin",              category: "tablas"             },
  { label: "Localidades",                     url: "/localidades/admin",                category: "tablas"             },
  { label: "Tipo Localización",               url: "/tipo_localizacion/admin",          category: "tablas"             },
  { label: "Estado Civil",                    url: "/estado_civil/admin",               category: "tablas"             },
  { label: "Género",                          url: "/genero/admin",                     category: "tablas"             },
  { label: "Categorías Parámetro",            url: "/categorias_parametro/admin",       category: "tablas"             },
  { label: "Tipo Cambio",                     url: "/tipo_cambio/admin",                category: "tablas"             },

  { label: "Tipo Cuentas",                    url: "/tipo_cuentas/admin",               category: "cuentas"            },
  { label: "Cuentas Personas Jurídicas",      url: "/cuentas_personas/admin_juridicas", category: "cuentas"            },
  { label: "Cuentas-Servicios",               url: "/cuentas_servicios/admin",          category: "cuentas"            },
  { label: "Tipo Cuentas-Servicios",          url: "/tipo_cuentas_servicios/admin",     category: "cuentas"            },
  { label: "Ficha Individual",                url: "/cuentas/ficha",                    category: "cuentas"            },
  { label: "Categorías",                      url: "/categorias/admin",                 category: "cuentas"            },
  { label: "Propiedades / Servicios",         url: "/servicios/admin",                  category: "cuentas"            },

  { label: "Consulta Comprobantes",           url: "/comprobantes/consulta",            category: "comprobantes"       },
  { label: "Carga Comprobantes",              url: "/comprobantes/carga",               category: "comprobantes"       },
  { label: "Comprobantes Códigos",            url: "/comprobantes_codigos/admin",       category: "comprobantes"       },
  { label: "Comprobantes Tipo",               url: "/comprobantes_tipo/admin",          category: "comprobantes"       },
  { label: "Comprobantes Estados",            url: "/comprobantes_estados/admin",       category: "comprobantes"       },
  { label: "Documento Tipo",                  url: "/documento_tipo/admin",             category: "comprobantes"       },
  { label: "Servicios de Guarda",             url: "/comprobantes/servicios_guarda",    category: "comprobantes"       },

  { label: "Tipos de Cajas",                  url: "/tipo_cajas/admin",                 category: "gestion_documental" },
  { label: "Tipos de Ubicaciones",            url: "/tipo_ubicaciones/admin",           category: "gestion_documental" },
  { label: "Tipos de Contenidos",             url: "/tipo_contenidos/admin",            category: "gestion_documental" },
  { label: "Estado de Cajas",                 url: "/estado_cajas/admin",               category: "gestion_documental" },
  { label: "Estado de Ubicaciones",           url: "/estado_ubicaciones/admin",         category: "gestion_documental" },
  { label: "Tipos de Estantes",               url: "/tipo_estantes/admin",              category: "gestion_documental" },
  { label: "Administración de Ubicaciones",   url: "/ubicaciones/admin",                category: "gestion_documental" },
  { label: "Administración de Estantes",      url: "/ubicaciones/estantes",             category: "gestion_documental" },
  { label: "Impresión etiquetas cajas",       url: "/ubicacion_etiquetas/proceso",      category: "gestion_documental" },
  { label: "Importación",                     url: "/importacion/contenidos",           category: "gestion_documental" },
  { label: "Movimientos",                     url: "/movimientos/historico",            category: "gestion_documental" },
  { label: "Gestión Documental - Cajas",      url: "/procesos/general",                 category: "gestion_documental" },
  { label: "Gestión Documental - Contenidos", url: "/procesos/general_contenidos",      category: "gestion_documental" },
  { label: "Digitalizaciones",                url: "/digitalizacion/admin",             category: "gestion_documental" },
  { label: "Ubicación Cajas Genéricas",       url: "/cajas_genericas/ubicacion",        category: "gestion_documental" },
  { label: "Asignación Cajas Genéricas",      url: "/cajas_genericas/asignacion",       category: "gestion_documental" },
  { label: "Contenidos Caja Genérica",        url: "/cajas_genericas/contenidos",       category: "gestion_documental" },
  { label: "Alojamiento Caja Genérica",       url: "/cajas_genericas/alojamiento",      category: "gestion_documental" },

  { label: "Artículos Tipo",                  url: "/articulos_tipo/admin",             category: "articulos"          },
  { label: "Tipo Servicios Internet",         url: "/tipo_servicios_internet/admin",    category: "articulos"          },
];

// ─── Utilidades ─────────────────────────────────────────────────────────────
function filterSuggestions(query) {
  if (!query) return [];
  const q = query.toLowerCase();
  return ALL_SUGGESTIONS.filter(
    (s) => s.label.toLowerCase().includes(q) || s.url.toLowerCase().includes(q)
  );
}

function groupByCategory(items) {
  return items.reduce((acc, item) => {
    if (!acc[item.category]) acc[item.category] = [];
    acc[item.category].push(item);
    return acc;
  }, {});
}

function HighlightMatch({ text, query }) {
  if (!query) return <span>{text}</span>;
  const idx = text.toLowerCase().indexOf(query.toLowerCase());
  if (idx === -1) return <span>{text}</span>;
  return (
    <span>
      {text.slice(0, idx)}
      <strong>{text.slice(idx, idx + query.length)}</strong>
      {text.slice(idx + query.length)}
    </span>
  );
}

// ─── Styled: barra del header ────────────────────────────────────────────────
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": { backgroundColor: alpha(theme.palette.common.white, 0.25) },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 1),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(2)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "16ch",
      "&:focus": { width: "28ch" },
    },
  },
}));

// ─── Componente principal ────────────────────────────────────────────────────
export default function SearchComponentHeader() {
  const theme = useTheme();
  const history = useHistory();

  const [headerValue, setHeaderValue] = useState("");
  const [popperOpen, setPopperOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalValue, setModalValue] = useState("");
  const [modalActiveIndex, setModalActiveIndex] = useState(-1);

  const searchRef = useRef(null);

  const popperResults = filterSuggestions(headerValue).slice(0, 6);
  const modalResults = filterSuggestions(modalValue);
  const modalGrouped = groupByCategory(modalResults);

  // ── Navegación en el Popper ──────────────────────────────────────────────
  const handleHeaderKeyDown = useCallback(
    (e) => {
      if (!popperOpen) return;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setActiveIndex((i) => Math.min(i + 1, popperResults.length - 1));
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setActiveIndex((i) => Math.max(i - 1, 0));
      } else if (e.key === "Enter") {
        e.preventDefault();
        if (activeIndex >= 0 && popperResults[activeIndex]) {
          navigateTo(popperResults[activeIndex].url);
        } else {
          openModal();
        }
      } else if (e.key === "Escape") {
        setPopperOpen(false);
        setActiveIndex(-1);
      }
    },
    [popperOpen, activeIndex, popperResults]
  );

  // ── Navegación en el Modal ───────────────────────────────────────────────
  const handleModalKeyDown = useCallback(
    (e) => {
      const flat = modalResults;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setModalActiveIndex((i) => Math.min(i + 1, flat.length - 1));
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setModalActiveIndex((i) => Math.max(i - 1, 0));
      } else if (e.key === "Enter") {
        e.preventDefault();
        if (modalActiveIndex >= 0 && flat[modalActiveIndex]) {
          navigateTo(flat[modalActiveIndex].url);
        }
      } else if (e.key === "Escape") {
        closeModal();
      }
    },
    [modalResults, modalActiveIndex]
  );

  const navigateTo = (url) => {
    setHeaderValue("");
    setPopperOpen(false);
    setActiveIndex(-1);
    closeModal();
    history.push(url);
  };

  const openModal = () => {
    setModalValue(headerValue);
    setModalActiveIndex(-1);
    setModalOpen(true);
    setPopperOpen(false);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalValue("");
    setModalActiveIndex(-1);
  };

  // ─── Header input ──────────────────────────────────────────────────────────
  const handleHeaderChange = (e) => {
    const val = e.target.value;
    setHeaderValue(val);
    setActiveIndex(-1);
    setPopperOpen(val.length > 0);
  };

  const handleHeaderFocus = () => {
    if (headerValue.length > 0) setPopperOpen(true);
  };

  const handleClickAway = () => {
    setPopperOpen(false);
    setActiveIndex(-1);
  };

  // ─── Colores adaptativos ───────────────────────────────────────────────────
  const isDark = theme.palette.mode === "dark";
  const paperBg = theme.palette.background.paper;
  const borderColor = isDark
    ? alpha(theme.palette.common.white, 0.12)
    : alpha(theme.palette.common.black, 0.1);

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div ref={searchRef} style={{ position: "relative" }}>
        {/* ── Barra del header ── */}
        <Search>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            placeholder="Buscar..."
            inputProps={{ "aria-label": "search" }}
            value={headerValue}
            onChange={handleHeaderChange}
            onFocus={handleHeaderFocus}
            onKeyDown={handleHeaderKeyDown}
          />
        </Search>

        {/* ── Popper inline ── */}
        <Popper
          open={popperOpen && popperResults.length > 0}
          anchorEl={searchRef.current}
          placement="bottom-start"
          transition
          style={{ zIndex: 1400, width: searchRef.current?.offsetWidth || 320, minWidth: 320 }}
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={150}>
              <Paper
                elevation={8}
                sx={{
                  mt: 0.5,
                  borderRadius: 2,
                  overflow: "hidden",
                  border: `1px solid ${borderColor}`,
                  bgcolor: paperBg,
                }}
              >
                {popperResults.map((item, idx) => {
                  const meta = CATEGORY_META[item.category];
                  const CatIcon = meta?.icon;
                  const isActive = idx === activeIndex;
                  return (
                    <ListItemButton
                      key={item.url}
                      selected={isActive}
                      onMouseEnter={() => setActiveIndex(idx)}
                      onClick={() => navigateTo(item.url)}
                      sx={{
                        px: 2,
                        py: 0.8,
                        gap: 1.5,
                        "&.Mui-selected": {
                          bgcolor: isDark
                            ? alpha(theme.palette.primary.main, 0.15)
                            : alpha(theme.palette.primary.main, 0.08),
                        },
                      }}
                    >
                      {/* Icono categoría */}
                      <Box
                        sx={{
                          width: 30,
                          height: 30,
                          borderRadius: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          bgcolor: isDark
                            ? alpha(theme.palette.primary.main, 0.18)
                            : alpha(theme.palette.primary.main, 0.1),
                          color: "primary.main",
                        }}
                      >
                        {CatIcon && <CatIcon sx={{ fontSize: 16 }} />}
                      </Box>

                      {/* Texto */}
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="body2" noWrap>
                          <HighlightMatch text={item.label} query={headerValue} />
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.disabled"
                          noWrap
                          sx={{ display: "block" }}
                        >
                          {item.url}
                        </Typography>
                      </Box>

                      {/* Badge categoría */}
                      <Chip
                        label={meta?.label}
                        size="small"
                        color={meta?.color || "default"}
                        variant="outlined"
                        sx={{ fontSize: 10, height: 20, flexShrink: 0 }}
                      />
                    </ListItemButton>
                  );
                })}

                {/* Footer "Ver todos" */}
                <Divider />
                <ListItemButton
                  onClick={openModal}
                  sx={{
                    px: 2,
                    py: 0.8,
                    justifyContent: "space-between",
                    color: "primary.main",
                  }}
                >
                  <Typography variant="caption" fontWeight={600}>
                    Ver todos los resultados ({filterSuggestions(headerValue).length})
                  </Typography>
                  <ArrowForwardIosIcon sx={{ fontSize: 11 }} />
                </ListItemButton>
              </Paper>
            </Fade>
          )}
        </Popper>

        {/* ── Modal completo ── */}
        <Dialog
          open={modalOpen}
          onClose={closeModal}
          fullWidth
          maxWidth="sm"
          PaperProps={{
            sx: {
              bgcolor: paperBg,
              backgroundImage: "none",
              borderRadius: 2,
              overflow: "hidden",
            },
          }}
        >
          {/* Cabecera del modal */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              px: 2,
              py: 1.5,
              borderBottom: `1px solid ${borderColor}`,
              gap: 1,
            }}
          >
            <SearchIcon color="action" />
            <TextField
              autoFocus
              fullWidth
              variant="standard"
              placeholder="Buscar sección o módulo..."
              value={modalValue}
              onChange={(e) => {
                setModalValue(e.target.value);
                setModalActiveIndex(-1);
              }}
              onKeyDown={handleModalKeyDown}
              InputProps={{
                disableUnderline: true,
                sx: { fontSize: 16 },
                endAdornment: modalValue && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setModalValue("")}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <IconButton size="small" onClick={closeModal}>
              <CloseIcon color="error" />
            </IconButton>
          </Box>

          {/* Cuerpo del modal */}
          <DialogContent sx={{ p: 0, maxHeight: "65vh" }}>
            {modalValue === "" ? (
              /* Estado vacío: accesos rápidos */
              <Box sx={{ p: 2 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  fontWeight={700}
                  sx={{ px: 1, mb: 1, display: "block", textTransform: "uppercase", letterSpacing: 0.8 }}
                >
                  Accesos rápidos
                </Typography>
                {ALL_SUGGESTIONS.filter((s) => s.category === "inicio").map((item) => {
                  const meta = CATEGORY_META[item.category];
                  const CatIcon = meta?.icon;
                  return (
                    <ListItemButton
                      key={item.url}
                      onClick={() => navigateTo(item.url)}
                      sx={{ borderRadius: 1, gap: 1.5, px: 1.5, py: 0.8 }}
                    >
                      <Box sx={{ color: "primary.main" }}>
                        {CatIcon && <CatIcon sx={{ fontSize: 18 }} />}
                      </Box>
                      <Typography variant="body2">{item.label}</Typography>
                    </ListItemButton>
                  );
                })}
              </Box>
            ) : modalResults.length === 0 ? (
              /* Sin resultados */
              <Box sx={{ py: 6, textAlign: "center" }}>
                <SearchIcon sx={{ fontSize: 48, color: "text.disabled", mb: 1 }} />
                <Typography color="text.secondary">
                  Sin resultados para <strong>"{modalValue}"</strong>
                </Typography>
              </Box>
            ) : (
              /* Resultados agrupados */
              <Box sx={{ pb: 1 }}>
                {Object.entries(modalGrouped).map(([cat, items]) => {
                  const meta = CATEGORY_META[cat];
                  const CatIcon = meta?.icon;
                  // calcular offset global para el active index
                  const catOffset = modalResults.indexOf(items[0]);
                  return (
                    <Box key={cat}>
                      {/* Cabecera de grupo */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          px: 2,
                          pt: 1.5,
                          pb: 0.5,
                        }}
                      >
                        <Box sx={{ color: "text.secondary", display: "flex" }}>
                          {CatIcon && <CatIcon sx={{ fontSize: 14 }} />}
                        </Box>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          fontWeight={700}
                          sx={{ textTransform: "uppercase", letterSpacing: 0.8 }}
                        >
                          {meta?.label}
                        </Typography>
                        <Divider sx={{ flex: 1 }} />
                      </Box>

                      {/* Items del grupo */}
                      {items.map((item, localIdx) => {
                        const globalIdx = catOffset + localIdx;
                        const isActive = globalIdx === modalActiveIndex;
                        return (
                          <ListItemButton
                            key={item.url}
                            selected={isActive}
                            onMouseEnter={() => setModalActiveIndex(globalIdx)}
                            onClick={() => navigateTo(item.url)}
                            sx={{
                              mx: 1,
                              borderRadius: 1,
                              px: 1.5,
                              py: 0.6,
                              gap: 1.5,
                              "&.Mui-selected": {
                                bgcolor: isDark
                                  ? alpha(theme.palette.primary.main, 0.15)
                                  : alpha(theme.palette.primary.main, 0.08),
                              },
                            }}
                          >
                            <Typography variant="body2" sx={{ flex: 1 }}>
                              <HighlightMatch text={item.label} query={modalValue} />
                            </Typography>
                            <Typography
                              variant="caption"
                              color="text.disabled"
                              sx={{ fontFamily: "monospace" }}
                            >
                              {item.url}
                            </Typography>
                          </ListItemButton>
                        );
                      })}
                    </Box>
                  );
                })}
              </Box>
            )}
          </DialogContent>

          {/* Footer del modal */}
          <Box
            sx={{
              px: 2,
              py: 1,
              borderTop: `1px solid ${borderColor}`,
              display: "flex",
              gap: 2,
              alignItems: "center",
            }}
          >
            {[
              { key: "↑↓", desc: "navegar" },
              { key: "↵",  desc: "ir"      },
              { key: "Esc", desc: "cerrar" },
            ].map(({ key, desc }) => (
              <Box key={key} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Box
                  component="kbd"
                  sx={{
                    px: 0.8,
                    py: 0.2,
                    borderRadius: 0.5,
                    border: `1px solid ${borderColor}`,
                    bgcolor: isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.05)",
                    fontSize: 11,
                    fontFamily: "monospace",
                    color: "text.secondary",
                  }}
                >
                  {key}
                </Box>
                <Typography variant="caption" color="text.disabled">
                  {desc}
                </Typography>
              </Box>
            ))}
            {modalResults.length > 0 && (
              <Typography variant="caption" color="text.disabled" sx={{ ml: "auto" }}>
                {modalResults.length} resultado{modalResults.length !== 1 ? "s" : ""}
              </Typography>
            )}
          </Box>
        </Dialog>
      </div>
    </ClickAwayListener>
  );
}
